<div class="d-none">
    <button [ngClass]="{'outline-btn': tab === 'agent'}" (click)="changeTab('agent')"
        class="tab-btn bg-color c-pointer">Agents</button>
    <button [ngClass]="{'outline-btn': tab === 'refree'}" (click)="changeTab('refree')"
        class="tab-btn bg-color c-pointer m-l-6">Referee</button>
</div>
<ng-container *ngIf="tab =='agent'">
    <div class="m-t-20">
        <mat-card-title class="m-l-10">Agents</mat-card-title>
        <mat-card class="cardWithShadow m-t-20">
            <mat-card-content>
                <div class="table-responsive">
                    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

                        <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->

                        <!-- Position Column -->
                        <ng-container matColumnDef="serialNumber">
                            <th mat-header-cell *matHeaderCellDef> Sr. </th>
                            <td mat-cell *matCellDef="let element"> {{element.position}} </td>
                        </ng-container>

                        <!-- Name Column -->
                        <ng-container matColumnDef="agentName">
                            <th mat-header-cell *matHeaderCellDef> Agent Name </th>
                            <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                        </ng-container>

                        <!-- Weight Column -->
                        <ng-container matColumnDef="email">
                            <th mat-header-cell *matHeaderCellDef> Email </th>
                            <td mat-cell *matCellDef="let element"> {{element.weight}} </td>
                        </ng-container>

                        <!-- Symbol Column -->
                        <ng-container matColumnDef="phoneNumber">
                            <th mat-header-cell *matHeaderCellDef> Phone Number </th>
                            <td mat-cell *matCellDef="let element"> {{element.symbol}} </td>
                        </ng-container>

                        <!-- Symbol Column -->
                        <!-- <ng-container matColumnDef="agentType">
                    <th mat-header-cell *matHeaderCellDef> Agent Type </th>
                    <td mat-cell *matCellDef="let element"> {{element.symbol}} </td>
                </ng-container> -->

                        <!-- Symbol Column -->
                        <ng-container matColumnDef="assignedLeads">
                            <th mat-header-cell *matHeaderCellDef> Approval Status </th>
                            <td mat-cell *matCellDef="let element"> {{element.symbol}} </td>
                        </ng-container>

                        <!-- Symbol Column -->
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef> Status </th>
                            <td mat-cell *matCellDef="let element"> {{element.symbol}} </td>
                        </ng-container>

                        <!-- Symbol Column -->
                        <!-- <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef> Action </th>
                <td mat-cell *matCellDef="let element"> {{element.symbol}} </td>
            </ng-container> -->

                        <!-- <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef>Actions</th>
                    <td mat-cell *matCellDef="let row">
                        <button mat-button (click)="edit(row)">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button mat-button (click)="delete(row)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </ng-container> -->

                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef> Action </th>
                            <td mat-cell *matCellDef="let element">
                                <!-- Dropdown Button -->
                                <button mat-button [matMenuTriggerFor]="menu"><i
                                        class="fa-solid fa-ellipsis-vertical"></i></button>

                                <!-- Dropdown Menu -->
                                <mat-menu #menu="matMenu" class="">
                                    <div>
                                        <button mat-button (click)="viewDetail(element)">
                                            <mat-icon>remove_red_eye</mat-icon>View</button>
                                    </div>
                                    <div>
                                        <button mat-button
                                            (click)="edit(element)"><mat-icon>edit</mat-icon>Edit</button>
                                    </div>
                                    <div>
                                        <button mat-button (click)="approve(element)">
                                            <mat-icon>check_circle</mat-icon> Approve
                                        </button>
                                    </div>

                                    <div>
                                        <button mat-button (click)="reject(element)">
                                            <mat-icon>cancel</mat-icon> Reject
                                        </button>
                                    </div>
                                    <div>
                                        <button mat-button (click)="deleteItem(element)">
                                            <mat-icon>delete</mat-icon>Delete</button>
                                    </div>
                                    <!-- <button mat-menu-item (click)="onAction3(element)">Action 3</button> -->
                                </mat-menu>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </div>

                <mat-paginator #paginator [length]="dataSource.length" [pageIndex]="0" [pageSize]="10"
                    [pageSizeOptions]="[25, 50, 100, 250]">
                </mat-paginator>
            </mat-card-content>
        </mat-card>
    </div>
</ng-container>

<ng-container *ngIf="tab =='refree'">
    <div class="m-t-20">
        <app-refree-list></app-refree-list>
    </div>
</ng-container>